module.exports = __webpack_public_path__ + "img/coupon5_en.671f40fe.png";